export enum FintechProductInfoLinksLayout {
  Horizontal = "Horizontal",
  Vertical = "Vertical",
}
